<template>
  <sl-side-panel :destroyOnClose="true" v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="110">
      <FormItem label="合格证编号" prop="certNo">
        <Input v-model="form.certNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="一致性证书编号" prop="cocNo">
        <Input v-model="form.cocNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车辆颜色" prop="color">
        <Input v-model="form.color" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车辆类型" prop="categoryId">
        <sl-select dict="carcate" v-model="form.categoryId" />
      </FormItem>
      <FormItem label="车辆品牌" prop="brand">
        <Input v-model="form.brand" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电机号" prop="motorNo">
        <Input v-model="form.motorNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车架号" prop="frameNo">
        <Input v-model="form.frameNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车辆编号" prop="carNo">
        <Input v-model="form.carNo" :maxlength="64" :disabled="isEdit" ></Input>
      </FormItem>
      <FormItem label="IMEI" prop="imei" v-if="!reviewDisabled">
        <Input :disabled="reviewDisabled" v-model="form.imei" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电池类型" prop="battery.type">
        <sl-select dict="$$battery_type" v-model="form.battery.type" />
      </FormItem>
      <FormItem label="电池电压" prop="battery.voltage">
        <sl-select dict="$$voltage" v-model="form.battery.voltage" />
      </FormItem>
      <FormItem label="电池电量" prop="battery.electricity">
        <sl-select dict="$$electricity" v-model="form.battery.electricity" />
      </FormItem>
      <FormItem label="电池序号" prop="battery.batteryNo">
        <Input v-model="form.battery.batteryNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电池规格" prop="battery.specs">
        <Input v-model="form.battery.specs" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电池品牌" prop="battery.brand">
        <Input v-model="form.battery.brand" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车牌号" prop="license.licenseNo">
        <Input v-model="form.license.licenseNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="所属企业" prop="companyId" v-if="!reviewDisabled">
        <sl-select dict="company" v-model="form.companyId" :filterable="true" :disabled="!extraEditable || reviewDisabled" />
      </FormItem>
      <FormItem label="登记时间" prop="enrollDatetime" v-if="!reviewDisabled">
        <DatePicker :disabled="reviewDisabled" type="date" v-model="form.enrollDatetime"></DatePicker>
      </FormItem>
      <FormItem label="保单号" prop="insurance.insuranceNo">
        <Input v-model="form.insurance.insuranceNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="保险方案" prop="insurance.insurance" v-if="!reviewDisabled">
        <insurance-select :disabled="reviewDisabled" v-model="state.insurance" />
      </FormItem>
      <FormItem v-if="state.insurance.length == 2" label="保险生效时间" prop="insurance.startDatetime">
        <DatePicker type="date" placeholder="选择投保时间" v-model="form.insurance.startDatetime"></DatePicker>
      </FormItem>
      <FormItem v-if="state.insurance.length == 2" label="保险到期时间" prop="insurance.endDatetime">
        <DatePicker disabled type="date" :options="insuranceEndOptions" placeholder="保险到期时间" v-model="form.insurance.endDatetime"></DatePicker>
      </FormItem>
      <FormItem label="购车方案" prop="buyOptions" v-if="!reviewDisabled">
        <sl-select dict="$buyOptions" v-model="form.buyOptions" :disabled="!extraEditable || reviewDisabled" />
      </FormItem>
      <FormItem label="计费规则" prop="carBillingRulesId" v-if="extraEditable && form.buyOptions == 1 && !reviewDisabled">
        <sl-select :disabled="reviewDisabled" :data="billingRules" v-model="form.carBillingRulesId" />
      </FormItem>
      <FormItem label="计费规则" v-if="!extraEditable && form.buyOptions == 1">
        <p>{{carBillingRules}}</p>
      </FormItem>
      <FormItem label="图片" prop="photo">
        <sl-upload :public="true" style="margin-top:8px;" v-model="form.photo" :type="27" :limit="20">支持格式：jpg, png, bmp , gif。最少4张，最多20张。</sl-upload>
      </FormItem>

      <FormItem label="备注" prop="remark">
        <!-- <sl-editor v-model="form.remark" /> -->
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
// import { imeiValidator } from '../partial/validator'
import { buyOptionsDisplay } from '../partial/utils'
import insuranceSelect from '../partial/insuranceSelect'
import moment from '@/util/format/moment'
import global from '@/util/mixin/global'
const getIdFromData = (data , billing) => {
  let hit = data.find(i => (
    i.raw.clearingType == billing.clearingType && 
    i.raw.stagesPrice == billing.stagesPrice && 
    i.raw.stagesNum == billing.stagesNum
  ))
  if(hit){
    return hit.raw.id
  }else{
    return null
  }
}

export default {
  components:{ insuranceSelect },
  mixins:[global],
  data() {
    const imeiValidator = (rule, value, callback) => {

      if (value === '') {
        if (rule.required) callback(new Error('请输入IMEI'));
      } else {
        this.$request.devices({search:{imei:value}}).then(resp => {
          let hit = resp.data.list
          if(hit.length == 0){
            callback(new Error('该设备不存在'))
          }
          else if(hit.length == 1){
            if(hit[0].carNo && hit[0].carNo != this.carNo){
              callback(new Error('该设备已被绑定'))
            }else{
              callback()
            }
          }else{
            callback(new Error('该设备不可用，未知错误'))
          }
        })
      }
    }
    return {
      rules: {

        brand: [
          { required: true, message: '车辆品牌不能为空', trigger: 'blur,change' },
        ],
        categoryId: [
          { type: 'number', required: true, message: '请选择车辆类型', trigger: 'blur,change' },
        ],
        motorNo: [
          { required: false, message: '请输入电机号', trigger: 'blur,change' },
        ],
        frameNo: [
          { required: true, message: '车架号不能为空', trigger: 'blur,change' },
        ],
        'battery.voltage': [
          { type: 'number', required: false, message: '请选择电池电压', trigger: 'blur,change' },
        ],
        'battery.electricity': [
          { type: 'number', required: false, message: '请选择电池电量', trigger: 'blur,change' },
        ],
        'battery.type': [
          { type: 'number', required: true, message: '请选择电池类型', trigger: 'blur,change' },
        ],
        'battery.batteryNo': [
          { required: false, message: '请输入电池序号', trigger: 'blur,change' },
        ],
        'battery.spec': [
          { required: true, message: '请输入电池规格', trigger: 'blur,change' },
        ],
        'insurance.startDatetime':[
          { required: true, type:'date', message: '请输入生效时间', trigger: 'blur,change' },
        ],
        // 'insurance.endDatetime':[
        //   { required: true, type:'date', message: '请输入到期时间', trigger: 'blur,change' },
        // ],
        imei: [
          { required: true, message: 'IMEI不能为空', trigger: 'blur,change' },
          { validator: imeiValidator, trigger: 'blur' },
        ],
        buyOptions: [
          { type: 'number', required: true, message: '请选择购车方案', trigger: 'blur,change' },
        ],
        companyId: [
          { type: 'number', required: true, message: '请选择所属企业', trigger: 'blur,change' },
        ],
        carBillingRulesId: [
          { type: 'number', required: true, message: '请选择计费规则', trigger: 'blur,change' },
        ],
        enrollDatetime:[
          { type: 'date', required: true, message: '请选择登记时间', trigger: 'blur,change' },
        ],
        photo:[
          { required: false, min:4 ,max:20, type:'array', message: '图片数量4-20张', trigger: 'blur,change' },
        ]
      },
      def: {},
      form: {
        id: null,
        brand: null,
        categoryId: null,
        deviceId: null,
        motorNo: null,
        frameNo: null,
        vin: null,
        imei: null,
        carNo: null,
        companyId: null,
        remark: null,
        enrollDatetime: null,
        buyOptions: null,
        carBillingRulesId: null,
        certNo:null,
        cocNo:null,
        color:null,
        photo:null,
        battery: {
          type:null,
          voltage:null,
          electricity:null,
          batteryNo:null,
          spec:null,
        },
        insurance: {},
        license: {},
        billing: {}
      },
      state:{
        insurance:[]
      },
      carNo: null,
      loading: false,
      billingRules: [],
      modalVisible: false,
      raw: {},
      api:{
        query:'car',
        create:'carCreate',
        update:'carUpdate'
      }
    }
  },

  computed: {
    insuranceEndOptions(){
      if( this.form.insurance.startDatetime ){
        return {
          disabledDate: (date) => {
            return date && (date.valueOf() < this.form.insurance.startDatetime.valueOf());
          }
        }
      }else{
        return {
          disabledDate: () => true
        }
      }
    },
    itemTitle() {
      return this.carNo ? '编辑车辆' : '新增车辆'
    },
    isEdit() {
      return !!this.form.id
    },
    carBillingRules() {
      return buyOptionsDisplay(this.raw)
    },
    //在车辆状态为行驶中时，不能更改企业；在车辆为其他状态且有绑定快递员时。更改企业后自动解绑
    companyEdit(){
      if(this.isEdit){
        //未启用收费规则 且 未启动
        if(this.data.billingState == 0 && this.data.startState == 0 ){
          return true
        }else{
          return false
        }
      }
    },
    insurances(){
      return this.$request.insuranceSelect().then( resp => {
        return Promise.resolve((resp.data || []).map(i => ({
          value:i.id , label:i.insuranceName
        })))
      })
    },
    //v1.1.7 需求 。
    // 扩展编辑： 车辆未启用时  【可】更改 【关联企业】及 【购车方案】
    // 新增时 可编辑
    extraEditable(){
      return this.raw.enableState == 0 || !this.form.id
    },

    //超级管理员可改 imei
    reviewDisabled(){
      return !this.isAdmin
    }
  },
  created() {
    this.def = { ...this.form }
    
    this.$request.ruleQuery({ pageSize: 99999, search: { state: 0 } }).then(resp => {
      resp.data.list = this.$utils.conv(resp.data.list, { clearingType: '$clearingType' })
      this.billingRules = resp.data.list.map(i => ({
        value: i.id,
        label: i.name,
        raw:i,
        placeholder: `${i.stagesPrice.toFixed(2)} x ${i.stagesNum}期 ${i.clearingTypeText}`
      }))
    })
  },

  methods: {

    init(id) {
      this.carNo = id
      this.reset()
      this.modalVisible = true
      if (this.carNo) {
        this.query()
      }
    },

    query() {
      this.$request(this.api.query)(this.carNo).then(resp => {
        if (!resp.data.battery) resp.data.battery = {}
        if (!resp.data.insurance) resp.data.insurance = {}
        if (!resp.data.license) resp.data.license = {}
        if (!resp.data.billing) resp.data.billing = {}
        this.$utils.conv(resp.data.billing, { clearingType: '$clearingType' })
        resp.data.carBillingRulesId = getIdFromData(this.billingRules , resp.data.billing)
        resp.data.billingState = resp.data.billing ? resp.data.billing.state : 0

        resp.data.photo = resp.data.photo ? resp.data.photo.split(';') : []

        let insuranceData = []
        if( resp.data.insurance.insuranceCompanyName ){
          insuranceData.push( resp.data.insurance.insuranceCompanyName )

          if( resp.data.insurance.insuranceId ){
            insuranceData.push( resp.data.insurance.insuranceId )
          }
        }

        if( resp.data.enrollDatetime ) resp.data.enrollDatetime = new Date(resp.data.enrollDatetime)
        if( resp.data.insurance.startDatetime ) resp.data.insurance.startDatetime = new Date(resp.data.insurance.startDatetime)
        if( resp.data.insurance.endDatetime ) resp.data.insurance.endDatetime = new Date(resp.data.insurance.endDatetime)
        
        this.state.insurance = insuranceData
        this.raw = resp.data
        this.$utils.fill(this.form, resp.data)

      })


    },

    reset() {
      this.$utils.fill(this.form, this.def)
      this.$utils.fill(this.form.battery , {
        type:null,
        voltage:null,
        electricity:null,
        batteryNo:null,
        spec:null,
      })

      this.state.insurance = []

      try {
        this.$refs['form'].resetFields()
      } catch (e) {
        console.log(e)
      }

    },

    save() {
      //
      let { photo , ...params } = this.form
      if( Array.isArray(photo) ) params.photo = photo.join(';')
      
      params.insurance.insuranceCompanyName = this.state.insurance[0]
      params.insurance.insuranceId = this.state.insurance[1]
      this.loading = true
      let promise = this.carNo ? this.$request(this.api.update) : this.$request(this.api.create)
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          //if (!this.carNo) {
            this.modalVisible = false
          //}
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    }
  }
}

</script>
